import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@blueprintjs/core';

/**
 * @props {function} onClick - required
 * @props {array} options - required
 * @props {array} colors - required
 */
class TaskStatusSelector extends Component {
	render() {
		return (
			<div className={"TaskStatusSelector"}>
				{this.options()}
			</div>
		)
	}

	options() {
		const { onClick, field, options, colors, index } = this.props;
		let arrOptions = Object.values(options);
		let arrColors = Object.values(colors);

		return arrOptions.map((option, i) => {

			return <div className={"TaskStatusItem"} key={option + '__' + i}>
				< Button
					onClick={() => onClick(option, { attr: field[0], index: index })}
					title=''
				>
					<Icon
						icon={'star'}
						iconSize={field[1] === option ? '20' : 12}
						title=''
						color={arrColors[i]}
					/>
				</Button >
			</div>
		})
	}
}

TaskStatusSelector.propTypes = {
	onClick: PropTypes.func.isRequired,
	classNameAdd: PropTypes.string,
}

TaskStatusSelector.defaultProps = {
	classNameAdd: '',
}

export default TaskStatusSelector;


// WEBPACK FOOTER //
// ./src/components/projectmanager/TaskStatusSelector.jsx